// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__Y96sW","modalFooterButton":"ModalNotes_modalFooterButton__2o2k8"};